import { useMemo } from 'react'

import './styles/status.scss'

interface Props {
    status: string;
    data?: any;
    type?: string;
}

export default function Status({status, data, type}: Props) {
    const classNames = `status-block ${status === 'active' ? 'active' : ''}`

    const text = useMemo(() => {
        if(type === 'movies' && data && data.status_name) {
            return data.status_name
        }

        return status === 'active' ? 'Активен' : 'Неактивен';
    }, [data, status, type])

    return (
        <label className={classNames}>
            { text }
        </label>
    )
}